export default __webpack_public_path__ + "static/media/leo.24550ca5.png";